import classNames from 'classnames';

import style from './style.module.css';

const SpinnerContainer = ({ children, className = '' }) => <div className={classNames(style.root, className)}>{children}</div>;

export default SpinnerContainer;
